<template>
  <step-block
    class="step-block--profile"
    v-bind="$attrs"
    v-on="$listeners"
    :title="name"
    :subtitle="label"
    :labels="innovations"
    :cover-image="photo"
    :attributes="attributes"
    :zoomable="true"
    :zoom-image="photo"
  />
</template>

<script>
  export default {
    name: 'ProfileBlock',
    props: {
      id: {},
      name: String,
      label: String,
      photo: String,
      attributes: {
        type: Array,
        default: () => [],
      },
      innovations: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>
